<template lang="pug">
  div.target.target-update
    e-modal(
    ref="modalForm"
    @confirm="sendForm()"
    @close="closeForm()"
    :title="title"
    :hideDeleteButton="false"
    )
      slot
        e-form(:formValidator="formValidator")
          div.body-wrapper.cuscroll
            div
              div.body
                div.col
                  e-form-group(
                  name="name"
                  inputType="textarea"
                  label="Наименование"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                  placeholder=" "
                  )
                  e-form-group(
                  name="document"
                  inputType="input"
                  label="Нормативный документ"
                  :model="fields"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="measure_id"
                  inputType="select"
                  label="Единица измерения"
                  :model="fields"
                  tabView="tab1"
                  :options="measureTypes"
                  :required="true"
                  )
                  div.col-block
                    label Период действия
                      div.dates
                        e-form-group(
                        formGroupStyle=" date-from"
                        name="start_year"
                        inputType="calendar"
                        label="От"
                        :model="fields"
                        tabView="tab1"
                        format="yyyy"
                        valueFormat="yyyy"
                        type="year"
                        )
                        e-form-group(
                        formGroupStyle=" date-to"
                        name="end_year"
                        inputType="calendar"
                        label="До"
                        format="yyyy"
                        valueFormat="yyyy"
                        :model="fields"
                        tabView="tab1"
                        type="year"
                        )

</template>

<script>
  import targetForm from './mixins/target-form.js'
  import {core, indicator} from '../../api/api-endpoints.js'

  export default {
    name: 'target-update',
    mixins: [targetForm],
    methods: {
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return indicator.object(route.params.id)
      },
      getUpdateOrCreateUrl () {
        return indicator.objectUpdateOrCreate(this.$route.params.id)
      },
      getCollectionEndpoint () {
        return core.collection('measure', {
          query: {
            type: 'indicator'
          }
        })
      }
    }
  }
</script>
